import axios from 'axios';
import { UserData } from '../store/reducers/userSlice';

// 1. MANUALLY DEFINE THE INTERFACE to bypass import errors
// This mimics the structure of an Axios response so TypeScript is happy.
interface CompatibleAxiosResponse<T = any> {
  data: T;
  status: number;
  statusText: string;
  headers: any;
  config: any;
  request?: any;
}

// 2. Create the instance
const instance = axios.create({});

// 3. Add Request Interceptor
// We use 'any' for config here to prevent type version mismatch errors
instance.interceptors.request.use(
  function (config: any) {
    const storedUser = localStorage.getItem('user');
    const token: UserData = storedUser ? JSON.parse(storedUser) : {
      userInfo: { id: -1, email: '', name: '' },
      accessToken: '',
    };
    
    // Safety check
    if (token.accessToken) {
        config.headers = config.headers || {};
        config.headers['Authorization'] = `Bearer ${token.accessToken}`;
    }
    
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// 4. DEFINE THE CUSTOM INSTANCE WRAPPER
// This tells TypeScript: "Assume all these methods return data of type 'any' (by default) 
// instead of 'unknown', but let me override it with <T> if I want to."
interface CustomAxiosInstance {
  get<T = any>(url: string, config?: any): Promise<CompatibleAxiosResponse<T>>;
  delete<T = any>(url: string, config?: any): Promise<CompatibleAxiosResponse<T>>;
  head<T = any>(url: string, config?: any): Promise<CompatibleAxiosResponse<T>>;
  post<T = any>(url: string, data?: any, config?: any): Promise<CompatibleAxiosResponse<T>>;
  put<T = any>(url: string, data?: any, config?: any): Promise<CompatibleAxiosResponse<T>>;
  patch<T = any>(url: string, data?: any, config?: any): Promise<CompatibleAxiosResponse<T>>;
  
  // Keep original interceptors/defaults accessible
  interceptors: typeof instance.interceptors;
  defaults: typeof instance.defaults;
}

// 5. THE FIX: Double Cast
// We cast to 'unknown' first to wipe the slate clean, then apply our custom type.
export const responseHero = instance as unknown as CustomAxiosInstance;